import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const scripturalReferenceMasterService = createApi({
  reducerPath: "scripturalReferenceMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["scripturalReferenceMaster"],
  endpoints: (builder) => ({
    getAllScripturalReferences: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scripturalReferenceMasterController.getAll}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchScripturalReferences: builder.mutation({
      query: (body) => ({
        url: userManagement.scripturalReferenceMasterController.search,
        method: "POST",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getScripturalReferenceById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scripturalReferenceMasterController.getById}/${body.id}`,
        method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveScripturalReference: builder.mutation({
      query: (body) => ({
        url: userManagement.scripturalReferenceMasterController.save,
        method: "POST",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateScripturalReference: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scripturalReferenceMasterController.update}/${body.id}`,
        method: "PUT",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    deleteScripturalReference: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scripturalReferenceMasterController.delete}/${body.id}`,
        method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    findAllScripturalReferences: builder.mutation({
      query: (body) => ({
        url: userManagement.scripturalReferenceMasterController.findAll,
        method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    bulkUploadScripturalReferences: builder.mutation({
      query: (body) => ({
        url: userManagement.scripturalReferenceMasterController.bulkUpload,
        method: "POST",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllScripturalReferencesMutation,
  useSearchScripturalReferencesMutation,
  useGetScripturalReferenceByIdMutation,
  useSaveScripturalReferenceMutation,
  useUpdateScripturalReferenceMutation,
  useDeleteScripturalReferenceMutation,
  useFindAllScripturalReferencesMutation,
  useBulkUploadScripturalReferencesMutation,
} = scripturalReferenceMasterService;
